import { useContext } from 'react';
import './CategoryPage.css';
import { ConfigContext } from '../../assets/contexts/configContext';
import { CATALOG_MAIN_LINK, FINE_ART_CATEGORY_LINK, HERMES_BAGS_CATEGORY_LINK, IMG_PLACEHOLDER_PRODUCT, JEWELRY_CATEGORY_LINK, WATCHES_CATEGORY_LINK } from '../../assets/utils/constants';
import { Link } from 'react-router-dom';
 
function CategoryPage() {
    const config = useContext(ConfigContext);
    
      const { initialConstants, cardTokens } = config;
      const { FIRST_LEVEL_CATEGORIES } = initialConstants;
      const { image_radius } = cardTokens;
    
      // Порядок отображения
      const DESIRED_ORDER = [
        WATCHES_CATEGORY_LINK,
        JEWELRY_CATEGORY_LINK,
        HERMES_BAGS_CATEGORY_LINK,
        FINE_ART_CATEGORY_LINK,
      ];
    
      // Фильтруем и сортируем категории в заданном порядке
      const ONLY_4_CATEGORIES = FIRST_LEVEL_CATEGORIES
        .filter((item) => DESIRED_ORDER.includes(item.translit_name))
        .sort(
          (a, b) =>
            DESIRED_ORDER.indexOf(a.translit_name) -
            DESIRED_ORDER.indexOf(b.translit_name)
        );

  return (
    <div className='category-page'>
         <p className="category-page__title">Categories</p>
             <div className="category-page__items">
               {ONLY_4_CATEGORIES && ONLY_4_CATEGORIES.length > 0
                 ? ONLY_4_CATEGORIES.map((item) => {
                     // Определяем, какое количество использовать:
                     // в приоритете item.count, если его нет — тогда item.published_count
                     const itemCount = item.count ?? item.published_count;
       
                     return (
                       <Link
                         className="category-page__item"
                         to={`/${CATALOG_MAIN_LINK}/${item.translit_name}`}
                         key={item.translit_name}
                       >
       
                         <div className="category-page__img-box">
                           <img
                             className="category-page__img"
                             src={
                               item.file ? item.file.urls.orig : IMG_PLACEHOLDER_PRODUCT
                             }
                             alt={item.name}
                           />
                         </div>
                         <div className="category-page__item-info">
                           {/* <div className="category-page__item-count-box">
                             <p className="category-page__item-count">{itemCount}</p>
                             <p className="category-page__item-count-title">
                               {getCountText(item.translit_name, itemCount)}
                             </p>
                           </div> */}
                           <p className="category-page__item-name">{item.name}</p>
                         </div>
                       </Link>
                     );
                   })
                 : null}
             </div>
    </div>
  );
}
 
export default CategoryPage